"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get IGNORE_TABLES () {
        return IGNORE_TABLES;
    },
    get extractAndGenerateManyToManyRelations () {
        return extractAndGenerateManyToManyRelations;
    },
    get populateMeta () {
        return populateMeta;
    },
    get populateRollupColumnAndHideLTAR () {
        return populateRollupColumnAndHideLTAR;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _inflection = require("inflection");
const _getUniqueName = require("./getUniqueName");
const _mapDefaultDisplayValue = /*#__PURE__*/ _interop_require_default(require("~/helpers/mapDefaultDisplayValue"));
const _getColumnUiType = /*#__PURE__*/ _interop_require_default(require("~/helpers/getColumnUiType"));
const _getTableName = /*#__PURE__*/ _interop_require_wildcard(require("~/helpers/getTableName"));
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _NcHelp = /*#__PURE__*/ _interop_require_default(require("~/utils/NcHelp"));
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _models = require("~/models");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const IGNORE_TABLES = [
    'nc_models',
    'nc_roles',
    'nc_routes',
    'nc_loaders',
    'nc_resolvers',
    'nc_hooks',
    'nc_store',
    '_evolutions',
    'nc_evolutions',
    'xc_users',
    'nc_rpc',
    'nc_acl',
    'nc_cron',
    'nc_disabled_models_for_role',
    'nc_audit',
    'xc_knex_migrations',
    'xc_knex_migrations_lock',
    'nc_plugins',
    'nc_migrations',
    'nc_api_tokens',
    'nc_projects',
    'nc_projects_users',
    'nc_relations',
    'nc_shared_views'
];
async function isMMRelationExist(context, model, assocModel, belongsToCol) {
    let isExist = false;
    const colChildOpt = await belongsToCol.getColOptions(context);
    for (const col of (await model.getColumns(context))){
        if ((0, _nocodbsdk.isLTARType)(col)) {
            const colOpt = await col.getColOptions(context);
            if (colOpt && colOpt.type === _nocodbsdk.RelationTypes.MANY_TO_MANY && colOpt.fk_mm_model_id === assocModel.id && colOpt.fk_child_column_id === colChildOpt.fk_parent_column_id && colOpt.fk_mm_child_column_id === colChildOpt.fk_child_column_id) {
                isExist = true;
                break;
            }
        }
    }
    return isExist;
}
async function extractAndGenerateManyToManyRelations(context, modelsArr) {
    for (const assocModel of modelsArr){
        await assocModel.getColumns(context);
        // check if table is a Bridge table(or Associative Table) by checking
        // number of foreign keys and columns
        const normalColumns = assocModel.columns.filter((c)=>!(0, _nocodbsdk.isVirtualCol)(c));
        const belongsToCols = [];
        for (const col of assocModel.columns){
            if (col.uidt == _nocodbsdk.UITypes.LinkToAnotherRecord) {
                const colOpt = await col.getColOptions(context);
                if ((colOpt == null ? void 0 : colOpt.type) === _nocodbsdk.RelationTypes.BELONGS_TO) belongsToCols.push(col);
            }
        }
        // todo: impl better method to identify m2m relation
        if ((belongsToCols == null ? void 0 : belongsToCols.length) === 2 && normalColumns.length < 5 && assocModel.primaryKeys.length === 2 && // check if both belongsToCol target primary keys
        assocModel.primaryKeys.every((pk)=>belongsToCols.some((c)=>{
                var _c_colOptions;
                return ((_c_colOptions = c.colOptions) == null ? void 0 : _c_colOptions.fk_child_column_id) === pk.id;
            }))) {
            const modelA = await belongsToCols[0].colOptions.getRelatedTable(context);
            const modelB = await belongsToCols[1].colOptions.getRelatedTable(context);
            await modelA.getColumns(context);
            await modelB.getColumns(context);
            // check tableA already have the relation or not
            const isRelationAvailInA = await isMMRelationExist(context, modelA, assocModel, belongsToCols[0]);
            const isRelationAvailInB = await isMMRelationExist(context, modelB, assocModel, belongsToCols[1]);
            if (!isRelationAvailInA) {
                await _Column.default.insert(context, {
                    title: (0, _getUniqueName.getUniqueColumnAliasName)(modelA.columns, (0, _inflection.pluralize)(modelB.title)),
                    fk_model_id: modelA.id,
                    fk_related_model_id: modelB.id,
                    fk_mm_model_id: assocModel.id,
                    fk_child_column_id: belongsToCols[0].colOptions.fk_parent_column_id,
                    fk_parent_column_id: belongsToCols[1].colOptions.fk_parent_column_id,
                    fk_mm_child_column_id: belongsToCols[0].colOptions.fk_child_column_id,
                    fk_mm_parent_column_id: belongsToCols[1].colOptions.fk_child_column_id,
                    type: _nocodbsdk.RelationTypes.MANY_TO_MANY,
                    uidt: _nocodbsdk.UITypes.Links,
                    meta: {
                        plural: (0, _inflection.pluralize)(modelB.title),
                        singular: (0, _inflection.singularize)(modelB.title)
                    }
                });
            }
            if (!isRelationAvailInB) {
                await _Column.default.insert(context, {
                    title: (0, _getUniqueName.getUniqueColumnAliasName)(modelB.columns, (0, _inflection.pluralize)(modelA.title)),
                    fk_model_id: modelB.id,
                    fk_related_model_id: modelA.id,
                    fk_mm_model_id: assocModel.id,
                    fk_child_column_id: belongsToCols[1].colOptions.fk_parent_column_id,
                    fk_parent_column_id: belongsToCols[0].colOptions.fk_parent_column_id,
                    fk_mm_child_column_id: belongsToCols[1].colOptions.fk_child_column_id,
                    fk_mm_parent_column_id: belongsToCols[0].colOptions.fk_child_column_id,
                    type: _nocodbsdk.RelationTypes.MANY_TO_MANY,
                    uidt: _nocodbsdk.UITypes.Links,
                    meta: {
                        plural: (0, _inflection.pluralize)(modelA.title),
                        singular: (0, _inflection.singularize)(modelA.title)
                    }
                });
            }
            await _Model.default.markAsMmTable(context, assocModel.id, true);
            // mark has many relation associated with mm as system field in both table
            for (const btCol of [
                belongsToCols[0],
                belongsToCols[1]
            ]){
                const colOpt = await btCol.colOptions;
                const model = await colOpt.getRelatedTable(context);
                for (const col of (await model.getColumns(context))){
                    if (!(0, _nocodbsdk.isLinksOrLTAR)(col.uidt)) continue;
                    const colOpt1 = await col.getColOptions(context);
                    if (!colOpt1 || colOpt1.type !== _nocodbsdk.RelationTypes.HAS_MANY) continue;
                    if (colOpt1.fk_child_column_id !== colOpt.fk_child_column_id || colOpt1.fk_parent_column_id !== colOpt.fk_parent_column_id) continue;
                    await _Column.default.markAsSystemField(context, col.id);
                    break;
                }
            }
        } else {
            if (assocModel.mm) await _Model.default.markAsMmTable(context, assocModel.id, false);
        }
    }
}
async function populateMeta(context, { source, base, logger, user }) {
    var _this, _data, _this1, _source_getConfig, _data_list_filter, _data_list, _data1, _this2, _source_getConfig1, _data_list1, _data2, _this3, _source_getConfig2;
    const info = {
        type: 'rest',
        apiCount: 0,
        tablesCount: 0,
        relationsCount: 0,
        viewsCount: 0,
        client: (_this = await (source == null ? void 0 : source.getConnectionConfig())) == null ? void 0 : _this.client,
        timeTaken: 0
    };
    const t = process.hrtime();
    const sqlClient = await _NcConnectionMgrv2.default.getSqlClient(source);
    let order = 1;
    const models2 = {};
    const virtualColumnsInsert = [];
    /* Get all relations */ const relations = (_this1 = await sqlClient.relationListAll({
        schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
    })) == null ? void 0 : (_data = _this1.data) == null ? void 0 : _data.list;
    info.relationsCount = relations.length;
    let tables = (_this2 = await sqlClient.tableList({
        schema: (_source_getConfig1 = source.getConfig()) == null ? void 0 : _source_getConfig1.schema
    })) == null ? void 0 : (_data1 = _this2.data) == null ? void 0 : (_data_list = _data1.list) == null ? void 0 : (_data_list_filter = _data_list.filter(({ tn })=>!IGNORE_TABLES.includes(tn))) == null ? void 0 : _data_list_filter.map((t)=>{
        t.order = ++order;
        t.title = (0, _getTableName.default)(t.tn, base.prefix, source);
        t.table_name = t.tn;
        return t;
    });
    /* filter based on prefix */ if (source.is_meta && (base == null ? void 0 : base.prefix)) {
        tables = tables.filter((t)=>{
            var _t_tn;
            return t == null ? void 0 : (_t_tn = t.tn) == null ? void 0 : _t_tn.startsWith(base == null ? void 0 : base.prefix);
        });
    }
    info.tablesCount = tables.length;
    tables.forEach((t)=>{
        t.title = (0, _getTableName.default)(t.tn, base.prefix, source);
    });
    relations.forEach((r)=>{
        r.title = (0, _getTableName.default)(r.tn, base.prefix, source);
        r.rtitle = (0, _getTableName.default)(r.rtn, base.prefix, source);
    });
    let colMeta = null;
    if (source.type === 'pg') {
        colMeta = {
            format: (await sqlClient.getDefaultByteaOutputFormat()).data
        };
    }
    const userId = user == null ? void 0 : user.id;
    // await this.syncRelations();
    const tableMetasInsert = tables.map((table)=>{
        return async ()=>{
            var _data, _this, _source_getConfig;
            logger == null ? void 0 : logger(`Populating meta for table '${table.title}'`);
            /* filter relation where this table is present */ const tableRelations = relations.filter((r)=>r.tn === table.tn || r.rtn === table.tn);
            const columns = (_this = await sqlClient.columnList({
                tn: table.tn,
                schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
            })) == null ? void 0 : (_data = _this.data) == null ? void 0 : _data.list;
            const hasMany = table.type === 'view' ? [] : tableRelations.filter((r)=>r.rtn === table.tn);
            const belongsTo = table.type === 'view' ? [] : tableRelations.filter((r)=>r.tn === table.tn);
            (0, _mapDefaultDisplayValue.default)(columns);
            // add vitual columns
            const virtualColumns = [
                ...hasMany.map((hm)=>{
                    return {
                        uidt: _nocodbsdk.UITypes.Links,
                        type: 'hm',
                        hm,
                        title: (0, _inflection.pluralize)(hm.title),
                        meta: {
                            plural: (0, _inflection.pluralize)(hm.title),
                            singular: (0, _inflection.singularize)(hm.title)
                        }
                    };
                }),
                ...belongsTo.map((bt)=>{
                    // find and mark foreign key column
                    const fkColumn = columns.find((c)=>c.cn === bt.cn);
                    if (fkColumn) {
                        fkColumn.uidt = _nocodbsdk.UITypes.ForeignKey;
                        fkColumn.system = true;
                    }
                    return {
                        uidt: _nocodbsdk.UITypes.LinkToAnotherRecord,
                        type: 'bt',
                        bt,
                        title: `${bt.rtitle}`
                    };
                })
            ];
            // await Model.insert(base.id, base.id, meta);
            /* create nc_models and its rows if it doesn't exists  */ models2[table.table_name] = await _Model.default.insert(context, base.id, source.id, {
                table_name: table.tn || table.table_name,
                title: table.title,
                type: table.type || 'table',
                order: table.order,
                user_id: userId
            });
            // table crud apis
            info.apiCount += 5;
            let colOrder = 1;
            for (const column of columns){
                if (source.type === 'databricks') {
                    if (column.pk && !column.cdf) {
                        column.meta = {
                            ag: 'nc'
                        };
                    }
                }
                await _Column.default.insert(context, _extends({
                    uidt: column.uidt || (0, _getColumnUiType.default)(source, column),
                    fk_model_id: models2[table.tn].id
                }, column, {
                    title: (0, _getTableName.getColumnNameAlias)(column.cn, source),
                    column_name: column.cn,
                    order: colOrder++
                }, colMeta && column.dt === 'bytea' ? {
                    meta: colMeta
                } : {}));
            }
            virtualColumnsInsert.push(async ()=>{
                const columnNames = {};
                for (const column of virtualColumns){
                    var _find, _this, _models2_rel_tn, _models2_rel_tn1, _find1, _this1, _models2_rel_rtn, _models2_rel_rtn1;
                    // generate unique name if there is any duplicate column name
                    let c = 0;
                    while(`${column.title}${c || ''}` in columnNames){
                        c++;
                    }
                    column.title = `${column.title}${c || ''}`;
                    columnNames[column.title] = true;
                    logger == null ? void 0 : logger(`Populating meta for column '${column.title}'`);
                    const rel = column.hm || column.bt;
                    const rel_column_id = (_this = await (models2 == null ? void 0 : (_models2_rel_tn = models2[rel.tn]) == null ? void 0 : _models2_rel_tn.getColumns(context))) == null ? void 0 : (_find = _this.find((c)=>c.column_name === rel.cn)) == null ? void 0 : _find.id;
                    const tnId = models2 == null ? void 0 : (_models2_rel_tn1 = models2[rel.tn]) == null ? void 0 : _models2_rel_tn1.id;
                    const ref_rel_column_id = (_this1 = await (models2 == null ? void 0 : (_models2_rel_rtn = models2[rel.rtn]) == null ? void 0 : _models2_rel_rtn.getColumns(context))) == null ? void 0 : (_find1 = _this1.find((c)=>c.column_name === rel.rcn)) == null ? void 0 : _find1.id;
                    const rtnId = models2 == null ? void 0 : (_models2_rel_rtn1 = models2[rel.rtn]) == null ? void 0 : _models2_rel_rtn1.id;
                    try {
                        await _Column.default.insert(context, {
                            base_id: base.id,
                            db_alias: source.id,
                            fk_model_id: models2[table.tn].id,
                            cn: (0, _getUniqueName.getUniqueColumnName)(models2[table.tn].columns, column.cn),
                            title: (0, _getUniqueName.getUniqueColumnAliasName)(models2[table.tn].columns, column.title),
                            uidt: column.uidt,
                            type: column.hm ? 'hm' : column.mm ? 'mm' : 'bt',
                            // column_id,
                            fk_child_column_id: rel_column_id,
                            fk_parent_column_id: ref_rel_column_id,
                            fk_index_name: rel.cstn,
                            ur: rel.ur,
                            dr: rel.dr,
                            order: colOrder++,
                            fk_related_model_id: column.hm ? tnId : rtnId,
                            system: column.system,
                            meta: column.meta
                        });
                        // nested relations data apis
                        info.apiCount += 5;
                    } catch (e) {
                        console.log(e);
                    }
                    logger == null ? void 0 : logger(`Populated meta for column '${column.title}'`);
                }
            });
            logger == null ? void 0 : logger(`Populated meta for table '${table.title}'`);
        };
    });
    /* handle xc_tables update in parallel */ await _NcHelp.default.executeOperations(tableMetasInsert, source.type);
    await _NcHelp.default.executeOperations(virtualColumnsInsert, source.type);
    await extractAndGenerateManyToManyRelations(context, Object.values(models2));
    let views = (_this3 = await sqlClient.viewList({
        schema: (_source_getConfig2 = source.getConfig()) == null ? void 0 : _source_getConfig2.schema
    })) == null ? void 0 : (_data2 = _this3.data) == null ? void 0 : (_data_list1 = _data2.list) == null ? void 0 : _data_list1.map((v)=>{
        v.order = ++order;
        v.table_name = v.view_name;
        v.title = (0, _getTableName.default)(v.view_name, base.prefix, source);
        return v;
    });
    /* filter based on prefix */ if (source.is_meta && (base == null ? void 0 : base.prefix)) {
        views = tables.filter((t)=>{
            var _t_tn;
            return t == null ? void 0 : (_t_tn = t.tn) == null ? void 0 : _t_tn.startsWith(base == null ? void 0 : base.prefix);
        });
    }
    info.viewsCount = views.length;
    const viewMetasInsert = views.map((table)=>{
        return async ()=>{
            var _data, _this, _source_getConfig;
            const columns = (_this = await sqlClient.columnList({
                tn: table.table_name,
                schema: (_source_getConfig = source.getConfig()) == null ? void 0 : _source_getConfig.schema
            })) == null ? void 0 : (_data = _this.data) == null ? void 0 : _data.list;
            (0, _mapDefaultDisplayValue.default)(columns);
            /* create nc_models and its rows if it doesn't exists  */ models2[table.table_name] = await _Model.default.insert(context, base.id, source.id, {
                table_name: table.table_name,
                title: (0, _getTableName.default)(table.table_name, base.prefix, source),
                // todo: sanitize
                type: _nocodbsdk.ModelTypes.VIEW,
                order: table.order,
                user_id: userId
            });
            let colOrder = 1;
            // view apis
            info.apiCount += 2;
            for (const column of columns){
                await _Column.default.insert(context, _extends({
                    fk_model_id: models2[table.table_name].id
                }, column, {
                    title: (0, _getTableName.getColumnNameAlias)(column.cn, source),
                    order: colOrder++,
                    uidt: (0, _getColumnUiType.default)(source, column)
                }));
            }
            logger == null ? void 0 : logger(`Populated meta for view '${table.title}'`);
        };
    });
    await _NcHelp.default.executeOperations(viewMetasInsert, source.type);
    // fix pv column for created grid views
    const models = await _Model.default.list(context, {
        base_id: base.id,
        source_id: source.id
    });
    for (const model of models){
        const views = await model.getViews(context);
        for (const view of views){
            if (view.type === _nocodbsdk.ViewTypes.GRID) {
                await _View.default.fixPVColumnForView(context, view.id);
            }
        }
    }
    const t1 = process.hrtime(t);
    const t2 = t1[0] + t1[1] / 1000000000;
    info.timeTaken = t2.toFixed(1);
    logger == null ? void 0 : logger(`Populating meta completed in ${t2.toFixed(1)}s`);
    return info;
}
async function populateRollupColumnAndHideLTAR(context, source, base) {
    for (const model of (await _Model.default.list(context, {
        base_id: base.id,
        source_id: source.id
    }))){
        const columns = await model.getColumns(context);
        const hmAndMmLTARColumns = columns.filter((c)=>c.uidt === _nocodbsdk.UITypes.LinkToAnotherRecord && c.colOptions.type !== _nocodbsdk.RelationTypes.BELONGS_TO && !c.system);
        const views = await model.getViews(context);
        for (const column of hmAndMmLTARColumns){
            var _relatedModel_primaryKey, _;
            const relatedModel = await column.getColOptions(context).then((colOpt)=>colOpt.getRelatedTable(context));
            await relatedModel.getColumns(context);
            const pkId = ((_relatedModel_primaryKey = relatedModel.primaryKey) == null ? void 0 : _relatedModel_primaryKey.id) || ((_ = (await relatedModel.getColumns(context))[0]) == null ? void 0 : _.id);
            await _Column.default.insert(context, {
                uidt: _nocodbsdk.UITypes.Links,
                title: (0, _getUniqueName.getUniqueColumnAliasName)(await model.getColumns(context), `${relatedModel.title}`),
                fk_rollup_column_id: pkId,
                fk_model_id: model.id,
                rollup_function: 'count',
                fk_relation_column_id: column.id,
                meta: {
                    singular: (0, _inflection.singularize)(relatedModel.title),
                    plural: (0, _inflection.pluralize)(relatedModel.title)
                }
            });
            const viewCol = await _models.GridViewColumn.list(context, views[0].id).then((cols)=>cols.find((c)=>c.fk_column_id === column.id));
            await _models.GridViewColumn.update(context, viewCol.id, {
                show: false
            });
        }
    }
}
